import React, { useState } from "react";
import {
  TextField,
  Typography,
  Button,
  Select,
  Radio,
  FormError,
  RegistrationModal,
  BeadCrumb,
  Loader,
} from "components";
import moment from "moment";
import { useSelector } from "react-redux";
import { routes } from "routes/apiRoutes";
import {
  formatPhoneNumber,
  isSuccessResponse,
  isAggregatorUser,
  bvnDateFormatter,
  setAlert,
} from "utils/helper";
import makeRequest from "services/makeRequest";
import { Formik, Form, ErrorMessage } from "formik";
import { FaRegUser } from "react-icons/fa";
import * as Yup from "yup";
import {
  genderOptions,
  userTypes,
  bvnValidationStatuses,
} from "utils/constants";
import {
  // nameValidation,
  phoneNumberValidation,
  emailValidation,
  bvnValidation,
  defaultValidation,
  // ninValidation,
} from "utils/validators";
import "./style.scss";

const CreateAgent = () => {
  const { user } = useSelector((state) => state.user);

  const [userNameType, setuserNameType] = useState(null);
  const [modalProps, setModalProps] = useState({
    contentMapper: null,
    validationText: "",
  });

  const [pmNumberValid, setPmNumberValid] = useState(null);

  const [BVNValid, setBVNValid] = useState(null);

  const [BVNState, setBVNState] = useState({
    bvn: "",
    bvnPresent: "",
    bvnValidated: "",
  });

  const [BVNValidationError, setBVNValidationError] = useState(null);
  const [showBVNField, setShowBVNField] = useState(false);

  const [userNameData, setUserNameData] = useState({
    status: false,
    suggestions: [],
  });

  const [error, setError] = useState("");

  const initialValues = {
    firstName: "",
    lastName: "",
    dob: "",
    gender: "",
    email: "",
    pmNumber: "",
    username: "",
    bvn: "",
    // nin: "",
  };

  const validationSchema = Yup.object({
    firstName: defaultValidation("First Name"),
    lastName: defaultValidation("Last Name"),
    dob: Yup.string().test(
      "dob",
      "Agent must not be less than 18 years",
      (value) => moment().diff(moment(value), "years") >= 18
    ),
    gender: defaultValidation("Gender"),
    email: emailValidation(),
    pmNumber: phoneNumberValidation("Phone Number", "phoneNumber", false),
    username: Yup.string().required("Username is required"),
    bvn: bvnValidation(),
    // nin: ninValidation(),
  });

  const { pmNumberValidation, userCreation, userNameValidation } = routes;

  const validatePmNumber = async (pmNumber, setFieldValue) => {
    setPmNumberValid(null);
    setBVNValidationError(null);

    setBVNState({
      bvn: "",
      bvnPresent: "",
      bvnValidated: "",
    });

    setModalProps({
      contentMapper: "validating",
      validationText: "Phone Number",
    });

    try {
      const { data } = await makeRequest("post", pmNumberValidation(), {
        pmNumber,
        isAuthenticated: true,
      });

      if (isSuccessResponse(data)) {
        setPmNumberValid(true);
        const { bvn, bvnpresent, bvnvalidated } = data?.data?.bvnDetails;
        setBVNState({
          ...BVNState,
          bvn: bvn,
          bvnPresent: bvnpresent,
          bvnValidated: bvnvalidated,
        });
        if (bvnvalidated) {
          setBVNValid(true);
        }

        if (!bvnvalidated) {
          setShowBVNField(true);
        }

        if (bvn) {
          setFieldValue("bvn", bvn);
        }

        handleModalClose();
      } else {
        setPmNumberValid(false);
        handleModalClose();
        // setModalProps({
        //   contentMapper: "invalidPmNumber",
        //   validationText: "",
        // });
      }
    } catch (err) {
      console.log("ERROR", err);
      handleModalClose();
      setAlert(err?.message);
    }
  };

  const validateBVN = async (bvn, firstName, lastName, dateOfBirth) => {
    setBVNValidationError(null);
    setBVNValid(false);
    setModalProps({
      contentMapper: "validating",
      validationText: "BVN",
    });

    try {
      const { data } = await makeRequest("post", routes.BVNValidation(), {
        bvn,
        firstName,
        lastName,
        dateOfBirth,
      });
      //   const { data } = await makeRequest("post", routes.BVNValidation(), {
      //     "firstName":"Teseer",
      //     "lastName": "Shaguy",
      //     "dateOfBirth" : "14-May-2018",
      //     "bvn" : "12345678901"
      // })

      if (isSuccessResponse(data)) {
        setBVNValid(true);
      } else {
        if (data?.Message && Array.isArray(data?.Message)) {
          setBVNValidationError(data.Message.join(", "));
        }
        if (data.responseMessage) setBVNValidationError(data.responseMessage);
      }
    } catch (err) {
      setAlert(err?.message);
    } finally {
      handleModalClose();
    }
  };

  const validateUserName = async (username) => {
    setUserNameData({ ...userNameData, status: "checking" });

    try {
      const { data } = await makeRequest("post", userNameValidation(), {
        username,
      });

      let returnedInfo = data.data;
      if (returnedInfo.userExists) {
        setUserNameData({
          status: false,
          suggestions: returnedInfo.suggestions,
        });
      } else {
        setUserNameData({ ...userNameData, status: true });
      }
    } catch (err) {
      setAlert(err?.message);
      setUserNameData({ ...userNameData, status: false });
    }
  };

  const handleModalClose = () => {
    setModalProps({
      content: null,
      validationText: "",
    });
  };

  const handleRegister = async (values, resetForm) => {
    setError("");

    let newValues = {
      ...values,

      //If PM was able to get agent's bvn, confirmation is "Validated"
      //If PM was able to get agent's bvn but status says its not validated, confirmation is "Pesent but not valid"
      //If PM wasnt able to get user's bvn at all, then confirmation is "Not Present"
      bvnConfirmation: BVNState.bvnValidated
        ? bvnValidationStatuses.validated
        : BVNState.bvn && !BVNState.bvnValidated
        ? bvnValidationStatuses.notValid
        : bvnValidationStatuses.notPresent,
      roles: [],
      userType: userTypes.agentUser,
      userName: values.username,
      dateOfBirth: values.dob,
      pmNumber: formatPhoneNumber(values.pmNumber),
      phoneNumber: formatPhoneNumber(values.pmNumber),
    };

    if (isAggregatorUser(user)) newValues.parentId = user?.agent_id;

    delete newValues.dob;
    delete newValues.username;

    try {
      const { data } = await makeRequest("post", userCreation(), newValues);
      if (isSuccessResponse(data)) {
        resetForm();
        setuserNameType(null);
        setPmNumberValid(null);
        setBVNValid(null);
        setModalProps({
          contentMapper: "registrationComplete",
        });
      } else {
        setAlert(data.responseMessage);
        // setError(data.responseMessage);
      }
    } catch (err) {}
  };

  return (
    <div className="my-4 pt-1">
      {console.log(pmNumberValid)}
      <div className="mt-4">
        <BeadCrumb titles={["Agent Management", "Create Agent"]} />
      </div>

      <div className="create-agent-form mx-auto">
        <div className="text-center">
          <Typography component="h3" variant="heading3" state="primary">
            Create Agent
          </Typography>
          <Typography className="font-danger" variant="body3" state="tetiary">
            You are required to fill all fields
          </Typography>
        </div>
        {error && (
          <div className="text-center">
            <Typography variant="body2" state="danger">
              {error}
            </Typography>
          </div>
        )}
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values, { resetForm }) =>
            handleRegister(values, resetForm)
          }
        >
          {({
            errors,
            touched,
            getFieldProps,
            setFieldValue,
            handleBlur,
            setFieldTouched,
            isSubmitting,
            values,
          }) => (
            <Form noValidate autoComplete="off">
              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <TextField
                    name="firstName"
                    type="text"
                    placeholder="Omolola"
                    label="Agent's First Name"
                    {...getFieldProps("firstName")}
                    hasError={errors.firstName && touched.firstName}
                    startIcon={<FaRegUser color="#AAA6A6" />}
                  />
                  <ErrorMessage component={FormError} name="firstName" />
                </div>

                <div className="col-md-6 mb-3">
                  <TextField
                    name="lastName"
                    type="text"
                    placeholder="Dave"
                    label="Agent's Last Name"
                    {...getFieldProps("lastName")}
                    hasError={errors.lastName && touched.lastName}
                    startIcon={<FaRegUser color="#AAA6A6" />}
                  />
                  <ErrorMessage component={FormError} name="lastName" />
                </div>

                <div className="col-md-6 mb-3">
                  <TextField
                    name="dob"
                    type="date"
                    label="Date of Birth"
                    {...getFieldProps("dob")}
                    onKeyDown={(e) => e.preventDefault()}
                    hasError={errors.dob && touched.dob}
                  />
                  <ErrorMessage component={FormError} name="dob" />
                </div>

                <div className="col-md-6 mb-3">
                  <Select
                    label="Gender"
                    placeholder="Select gender"
                    options={genderOptions}
                    name="gender"
                    {...getFieldProps("gender")}
                    hasError={errors.gender && touched.gender}
                  />
                  <ErrorMessage component={FormError} name="gender" />
                </div>

                <div className="mb-3">
                  <TextField
                    name="pmNumber"
                    type="number"
                    placeholder="Enter PM Number"
                    label="PocketMoni Phone Number"
                    value={values.pmNumber}
                    maxLength="11"
                    onChange={(e) => {
                      let val = e.target.value;
                      setFieldValue("pmNumber", val);
                      // if(userNameType === "pmNumber"){
                      //   setFieldValue("username", val)
                      // }
                      //In case bvn had been declared valid, user changes phoneNumber, we should reset as it also affects disabling bvn field
                      setBVNState({
                        ...BVNState,
                        bvnValidated: false,
                        bvn: "",
                        bvnPresent: false,
                      });
                      setShowBVNField(false);
                      setFieldValue("bvn", "");

                      if (pmNumberValid !== null) setPmNumberValid(null);
                      if (val.length === 11) {
                        validatePmNumber(formatPhoneNumber(val), setFieldValue);
                      }
                    }}
                    onBlur={handleBlur}
                    hasError={errors.pmNumber && touched.pmNumber}
                  />
                  {pmNumberValid && (
                    <Typography variant="caption1" state="success">
                      Pm Number exists!
                    </Typography>
                  )}

                  {pmNumberValid === false && (
                    <Typography variant="caption1" state="danger">
                      Pm Number does not exist! Agent should download PocketMoni
                      App or dial *389#
                    </Typography>
                  )}

                  <ErrorMessage component={FormError} name="pmNumber" />
                  <Typography variant="caption1">
                    Example: 08037589252
                  </Typography>
                </div>

                <div className="mb-3">
                  <TextField
                    name="email"
                    type="email"
                    placeholder="Enter Email Address"
                    label="Agent's Email Address"
                    {...getFieldProps("email")}
                    hasError={errors.email && touched.email}
                    startIcon={<FaRegUser color="#AAA6A6" />}
                  />
                  <ErrorMessage component={FormError} name="email" />
                </div>

                <div className={pmNumberValid ? "" : ""}>
                  <div className="mb-1">
                    <label htmlFor={"username"} className="pm-label">
                      Username
                      <span
                        style={{ marginLeft: ".2rem" }}
                        className="font-danger"
                      >
                        *
                      </span>
                    </label>
                    <div>
                      <Radio
                        value={values.email}
                        checked={userNameType === "email"}
                        onClick={() => {
                          let val = values.email;
                          setFieldValue("username", val);
                          setuserNameType("email");
                          if (val) {
                            validateUserName(val);
                          }
                        }}
                      />
                      <label htmlFor="emailAddress" className="register-label">
                        Use email address
                      </label>
                      <div className="phone-option">
                        <Radio
                          value={values.pmNumber}
                          // disabled={!values.pmNumber}
                          checked={userNameType === "pmNumber"}
                          onClick={() => {
                            let val = values.pmNumber;
                            setFieldValue("username", val);
                            setuserNameType("pmNumber");
                            if (val.length) {
                              validateUserName(val);
                            }
                          }}
                        />
                        <label htmlFor="phoneNumber" className="register-label">
                          Use phone number
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <TextField
                      name="Username"
                      type="text"
                      placeholder="Enter Username"
                      required={false}
                      value={values.username}
                      onChange={(e) => {
                        setFieldValue("username", e.target.value);
                        setuserNameType(null);
                        //only persist info when there are no suggestions so user can select from
                        if (!userNameData.suggestions.length)
                          setUserNameData({
                            status: false,
                            suggestions: [],
                          });
                      }}
                      onBlur={(e) => {
                        let val = e.target.value;
                        if (val.length) {
                          validateUserName(val);
                        } else {
                          setFieldTouched("username");
                        }
                      }}
                      hasError={errors.username && touched.username}
                    />

                    {values.username && (
                      <>
                        {userNameData.status === true && (
                          <Typography variant="caption1" state="success">
                            Username available
                          </Typography>
                        )}

                        {userNameData.status === "checking" && (
                          <Typography variant="caption1" state="secondary">
                            Checking if username is available{" "}
                            <span style={{ marginLeft: "1rem" }}>
                              <Loader
                                variant="secondary"
                                height={3}
                                width={1}
                                margin={-12}
                                color="#1966FC"
                              />
                            </span>
                          </Typography>
                        )}
                        {userNameData.status === false &&
                          userNameData.suggestions.length > 0 && (
                            <>
                              <Typography variant="caption1" state="danger">
                                {" "}
                                This Username is already chosen{" "}
                              </Typography>
                              <Typography
                                variant="body4"
                                state="primary"
                                component="span"
                              >
                                See suggestions:
                              </Typography>{" "}
                              <Typography variant="body4" component="span">
                                {userNameData.suggestions.map((name, index) =>
                                  index !== userNameData.suggestions.length - 1
                                    ? `${name}, `
                                    : `or ${name}.`
                                )}
                              </Typography>
                            </>
                          )}
                      </>
                    )}

                    <ErrorMessage component={FormError} name="username" />
                  </div>
                </div>

                {!showBVNField && (
                  <div className={``}>
                    <TextField
                      name="bvn"
                      type="number"
                      placeholder="Enter BVN"
                      value={values.bvn}
                      label="BVN"
                      disabled={BVNState.bvnValidated}
                      onChange={(e) => {
                        let val = e.target.value;
                        setFieldValue("bvn", val);
                        setBVNValidationError(null);
                        setBVNValid(false); //make sure we are revalidating the bvn
                        // setBvnFromAcc({ status: null });
                        if (val.length === 11) {
                          validateBVN(
                            val,
                            values.firstName,
                            values.lastName,
                            bvnDateFormatter(values.dob)
                          );
                        }
                      }}
                      onBlur={handleBlur}
                      hasError={errors.bvn && touched.bvn}
                    />

                    {!BVNValid &&
                      values.pmNumber &&
                      values.bvn.length === 11 && (
                        <Typography
                          className="text-underline cursor-pointer"
                          variant="caption1"
                          state="primary"
                          onClick={() =>
                            validateBVN(
                              values.bvn,
                              values.firstName,
                              values.lastName,
                              bvnDateFormatter(values.dob)
                            )
                          }
                        >
                          Validate BVN.
                        </Typography>
                      )}
                    <Typography variant="caption1" state="danger">
                      {BVNValidationError}
                    </Typography>
                    {BVNValid && (
                      <Typography variant="caption1" state="success">
                        {"BVN Successfully validated"}
                      </Typography>
                    )}
                    <ErrorMessage component={FormError} name="bvn" />
                  </div>
                )}
              </div>
              <div className="mb-4">
                {/* <TextField
                  name="nin"
                  type="number"
                  placeholder="Enter NIN"
                  value={values.nin}
                  label="NIN"
                  onChange={(e) => {
                    setFieldValue("nin", e.target.value);
                  }}
                  onBlur={handleBlur}
                  hasError={errors.nin && touched.nin}
                />
                <ErrorMessage component={FormError} name="nin" /> */}
              </div>
              <Button
                type="submit"
                label="Create Agent"
                disabled={
                  // !pmAccountValid ||
                  !pmNumberValid || !BVNValid || userNameData.status !== true
                }
                loading={isSubmitting}
                fullWidth
              />
            </Form>
          )}
        </Formik>
        <RegistrationModal
          modalContentMapper={modalProps.contentMapper}
          validationText={modalProps.validationText}
          showModal={!!modalProps.contentMapper}
          onClose={handleModalClose}
          self={false}
        />
      </div>
    </div>
  );
};

export default CreateAgent;
